/**
 * What the site says about itself to search engines and link previews: the
 * words that name what we do and where, used in titles, descriptions and the
 * structured data (montanhas-web#16, the SEO look of Oct 2026). Google ignores
 * a keywords meta tag; what counts is that the title, the description, the
 * heading and the text of a page say the same thing.
 */
export const SITE_TAGLINE = "Caminhadas em grupo no Norte de Portugal";

export const SITE_DESCRIPTION =
  "Caminhadas de um dia, fins de semana e viagens a pé pelas serras do Norte de Portugal, com líder, em grupo e em boa companhia. Inscreve-te online e vem caminhar connosco.";

/** the hero's photo, fixed: a photo of ours, chosen by hand; the image a link to the site shows too */
export const HERO_PHOTO = "programmes/36/photos/342468728327.jpeg";
/** what that photo shows, for whoever cannot see it and for an image search; change it with the photo */
export const HERO_ALT = "Grupo a caminhar por um caminho de floresta coberto de folhas, no outono";

/**
 * A page's Open Graph, whole: Next replaces the layout's object rather than
 * merging into it, so a page that names its title would lose the image and the
 * site name unless it gives them again.
 */
export const pageOpenGraph = (title: string, description: string | undefined, url: string) => ({
  type: "website" as const,
  siteName: "Montanhas Dentro",
  locale: "pt_PT",
  title,
  description,
  url,
  images: [{ url: `https://cdn.montanhasdentro.pt/${HERO_PHOTO}`, alt: SITE_TAGLINE }],
});

/**
 * What a page that is somebody's own, or only a way to other pages, says to a
 * search engine: not to keep it, and to follow its links. The account, the tabs
 * that are empty to a visitor, the menu, signing in. Given by a layout.tsx in
 * each of those folders, so every page under it says the same.
 */
export const NOT_INDEXED = { index: false, follow: true } as const;

/** what each page of the site says under its title in a search result */
export const PAGE_DESCRIPTIONS: Record<string, string> = {
  "sobre-nos": "Quem somos e porque caminhamos: a Montanhas Dentro organiza caminhadas em grupo, fins de semana e viagens a pé pelo Norte de Portugal desde 2021.",
  contactos: "Fala connosco: o email, o telefone e as redes da Montanhas Dentro, para qualquer dúvida sobre as nossas caminhadas.",
  "perguntas-frequentes": "As dúvidas mais comuns sobre as nossas caminhadas: quem pode participar, como te inscreves e pagas, o que levar, cancelamentos, seguros e boleias.",
  "termos-e-condicoes": "Os termos e condições de participação nas caminhadas e viagens da Montanhas Dentro.",
  "politica-de-privacidade": "Como a Montanhas Dentro trata os teus dados pessoais.",
  "politica-de-cookies": "Os cookies que o site da Montanhas Dentro usa e como os gerir.",
  "entidades-ral": "As entidades de resolução alternativa de litígios a que podes recorrer.",
  "eventos-passados": "Todas as caminhadas, fins de semana e viagens que a Montanhas Dentro já fez pelo Norte de Portugal, mês a mês, com as fotografias de quem foi.",
};
